import { onBeforeUnmount, onMounted, ref } from "vue"
import GTMregisterTotalkredit from '../PIMap/methods/GTMregisterTotalkredit'

export default {
    name: "CardMediumPI",
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        dropdownLabel: {
            type: String,
            default: ''
        },
        dropdownAriaLabel: {
            type: String,
            default: ''
        },
        piPartners: {
            type: Array,
            default: []
        },
        color: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const classNameColor = `nyk-card-medium${props.color}`
        const dropdownRef = ref(null)
        const dropdownAriaLabel = props.dropdownAriaLabel || props.dropdownLabel

        const normalizeWebsiteUrl = (url) => {
            if (!url) {
                return null
            }

            if (url.startsWith('http')) {
                return url
            }

            return `https://${url}`
        }

        const piPartners = props.piPartners
            .map(pi => ({
                ...pi,
                url: normalizeWebsiteUrl(pi.url)
            }))
            .filter(pi => pi.url)

        const trackClickEvent = (piName, isExternal) => {
            GTMregisterTotalkredit(
                'CardGalleryMapBlock',
                'gå til website - click', 
                piName, 
                isExternal ? "udenfor samarbejdet" : "indenfor samarbejdet", 
                piName
            )
        }

        const closeDropdown = ({ returnFocus = false } = {}) => {
            const dropdown = dropdownRef.value

            if (!dropdown?.hasAttribute('open')) {
                return
            }

            dropdown.removeAttribute('open')

            if (returnFocus) {
                dropdown.querySelector('summary')?.focus()
            }
        }

        const onDocumentClick = (event) => {
            if (!dropdownRef.value?.contains(event.target)) {
                closeDropdown()
            }
        }

        const onDropdownKeydown = (event) => {
            if (event.key !== 'Escape') {
                return
            }

            event.preventDefault()
            event.stopPropagation()
            closeDropdown({ returnFocus: true })
        }

        const onDropdownFocusOut = () => {
            window.setTimeout(() => {
                const dropdown = dropdownRef.value

                if (!dropdown?.hasAttribute('open')) {
                    return
                }

                if (!dropdown.contains(document.activeElement)) {
                    closeDropdown()
                }
            }, 0)
        }

        const onPartnerClick = (piName, isExternal) => {
            trackClickEvent(piName, isExternal)
            closeDropdown()
        }

        onMounted(() => {
            document.addEventListener('click', onDocumentClick)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', onDocumentClick)
        })

        return {
            classNameColor,
            dropdownRef,
            dropdownAriaLabel,
            onDropdownFocusOut,
            onDropdownKeydown,
            onPartnerClick,
            piPartners,
        }
    }
}
